module.exports = __webpack_public_path__ + "media/images/airplane-aa3ec296fe42b610c6c2f1d718f899d0.png";